<label class="field-label"><%= I18n.visit.labels.location_during_visit %></label>
<div class="field-input select">
  <select data-appointment-booking-wizard-behaviour="field-input" name="location_during_visit" required>
    <option value=""><%= I18n.prompts.state %></option>
    <% AppointmentBooking.config.states.forEach(function(stateOption) { %>
      <option value="<%= stateOption[1] %>" <% if (location_during_visit == stateOption[1]) { %>selected<% } %>><%= stateOption[0] %></option>
    <% }) %>
  </select>
</div>
<span class="validation-error"><%= I18n.errors.required_field %></span>
